var _polygon;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSmallCornerTriangle = function SvgSmallCornerTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 7
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0,7 7,7 7,0"
  })));
};

export default SvgSmallCornerTriangle;